import * as React from 'react'

import type { AmplitudeClient, AmplitudeInstance } from './amplitude'

export interface AmplitudeContextValue {
  /** `null` until tracking is allowed and the client is initialised. */
  amplitude: AmplitudeClient | null
  instance: AmplitudeInstance | null
}

export const AmplitudeContext = React.createContext<undefined | AmplitudeContextValue>(undefined)
